import React from "react";
import { MiddleSecWrapper } from "./style";
import { MiddleNftImg, ThumbNailImg } from "../../shared/icons";
import { Button } from "../Buttons";
import { useNavigate } from "react-router-dom";

const MiddleSectionScreenView = () => {
  const navigate = useNavigate();
  const isMobile = window.innerWidth <= 1024;

  return (
    <MiddleSecWrapper className="mt">
      <ul>
        <li>
          <h1>Driving Conservation</h1>
          <h1 className="subtitle">
            <span>
            Digital Asset Innovation
            </span>
          </h1>
          <p>
          Through the power of Digital Assets, we`re creating a platform where digital art meets real-world impact. By combining blockchain technology with conservation efforts, our mission is to drive awareness, fund sustainability projects, and build a community committed to a greener future.
          </p>
        </li>
        <li>
          <h2>Driving Conservation Forward with Digital Asset Innovation Mission</h2>
          <img src={MiddleNftImg} alt="nft img" />
        </li>
      </ul>
      {!isMobile && <div className="sticker" onClick={() => navigate("/marketplace")}>
        Start<br/>Discovery
      </div>}
    </MiddleSecWrapper>
  );
};

export default MiddleSectionScreenView;
